var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIntegration(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "var(--secondary-purple-200)",
    width: 54,
    height: 54,
    rx: 4
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.25 11.25)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#6E6EDB",
    width: 31.5,
    height: 31.5,
    rx: 1.75
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFFFFC"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.484 16.97a.627.627 0 00-.887 0l-1.438 1.438-1.622-1.622 1.438-1.438a.627.627 0 00-.887-.887l-1.438 1.438-1.333-1.332a.627.627 0 00-.887 0l-1.36 1.359a4.904 4.904 0 00-.411 6.473L6.56 24.497a.627.627 0 10.887.886l2.098-2.097a4.911 4.911 0 006.473-.412l1.36-1.36a.627.627 0 000-.887l-1.333-1.332 1.438-1.438a.627.627 0 000-.887zM25.01 6.934a.627.627 0 00-.886 0L22.026 9.03a4.917 4.917 0 00-6.473.412l-1.36 1.36a.627.627 0 000 .887l6.062 6.06a.627.627 0 00.887 0l1.36-1.359a4.904 4.904 0 00.411-6.473l2.098-2.097a.627.627 0 000-.887z"
  }))))));
}
export default SvgIntegration;